

import USDT from '../assets/usdt.png'
import arb from "../assets/chains/ARB.png"
import eth from "../assets/eth.png"






interface Token {
    name: string;
    address: string;
    symbol: string;
}


interface chain {
    name: string;
    contract: string;
    chainId: string;
    symbol: string;
    currency: {
        symbol: string;
        decimals: number;

    }
    | any;
    rpcs: string[];
    url: string
    tokens: Token[]
}




export const chainOptions: chain[] = [


    {
        name: "Arbitrum One", contract: '0xfc739432ba84371598d58f24982426ea66962dba', chainId: "0xa4b1", symbol: arb, currency: { symbol: "ETH", decimals: 18 }, rpcs: ['https://arb1.arbitrum.io/rpc'], url: "https://arbiscan.io/tx/", tokens: [


            { name: "ETH", address: "", symbol: eth },
            { name: "ARB", address: "0x912CE59144191C1204E64559FE8253a0e49E6548", symbol: arb },
            { name: "USDT", address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9", symbol: USDT },



        ]
    },


     {
        name: "Arbitrum Sepolia", contract: '0x88509C194af396936aBBf92E3EE11be106b91A4a', chainId: "0x66eee", symbol: arb, currency: { symbol: "ETH", decimals: 18 }, rpcs: ['https://sepolia-rollup.arbitrum.io/rpc'], url: "https://sepolia.arbiscan.io/tx/", tokens: [


            { name: "ETH", address: "", symbol: eth },
           



        ]
    },
 

        
   
    







]
